import { Injectable } from '@angular/core';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { ApproveContractCommandHandler } from './approve-contact-command-handler.service';
import { leaseAgreementCommand } from '../../command/lease-agreement.command';
import { DeleteCommandHandler } from '../../../core/service/command/delete-command-handler.service';
import { EditCommandHandler } from '../../../core/service/command/edit-command-handler.service';
import { TerminateContractCommandHandler } from './terminate-contract-command-handler.service';
import { WithdrawApprovalCommandHandler } from './withdraw-approval-command-handler.service';
import { WithdrawTerminationCommandHandler } from './withdraw-termination-command-handler.service';
import { PrintContractCommandHandler } from './print-contract-command-handler.service';
import { standardCommand } from '../../../core/model/command';
import { SendTenantMailCommandHandler } from '../../../message/service/command/send-tenant-mail-command-handler.service';
import { mailCommand } from '../../../message/model/const/command';
import { CreateInvoiceCommandHandler } from './create-invoice-command-handler.service';
import { PrintContractTerminationFormCommandHandler } from './print-contract-termination-form-command-handler';
import { PrintParkingContractFormCommandHandler } from './print-parkingcontract-command-handler';
import { ShowLeaseAgreementInvoicesCommandHandler } from './show-lease-agreement-invoices-command-handler';
import { LeaseAgreementExportCommandHandler } from './lease-agreement-export-command-handler.service';
import { LinkLeaseAgreementDocumentCommandHandler } from './link-lease-agreement-document-command-handler.service';
import { ShowDocumentsCommandHandler } from './show-documents-command-handler.service';
import { SendTenantSMSCommandHandler } from '../../../message/service/command/send-tenant-sms-command-handler.service';
import { VoidContractCommandHandler } from './void-contract-command-handler.service';
import { ESignLeaseAgreementContractCommandHandler } from './esign-lease-agreement-document-command-handler.service';
import { LeaseAgreementExportNoPersonalDataCommandHandler } from './lease-agreement-export-no-personal-data-command-handler.service';
import { ESignKeyRecieptCommandHandler } from './esign-key-reciept-document-command-handler.service';
import { SendTenantEmailCommandHandler } from '../../../message/service/command/send-tenant-email-command-handler.service';

@Injectable()
export class ContractCommandHandlerResolver extends CommandHandlerResolver {
  constructor(
    approveHandler: ApproveContractCommandHandler,
    createInvoiceHandler: CreateInvoiceCommandHandler,
    deleteHandler: DeleteCommandHandler,
    editHandler: EditCommandHandler,
    exportHandler: LeaseAgreementExportCommandHandler,
    exportNoPersonalDataHandler: LeaseAgreementExportNoPersonalDataCommandHandler,
    linkDocumentHandler: LinkLeaseAgreementDocumentCommandHandler,
    printTerminationFormHandler: PrintContractTerminationFormCommandHandler,
    sendEmailHandler: SendTenantEmailCommandHandler,
    sendMailHandler: SendTenantMailCommandHandler,
    sendSmsHandler: SendTenantSMSCommandHandler,
    terminateHandler: TerminateContractCommandHandler,
    voidHandler: VoidContractCommandHandler,
    esignLeaseAgreementDocumentHandler: ESignLeaseAgreementContractCommandHandler,
    withdrawApprovalHandler: WithdrawApprovalCommandHandler,
    withdrawTerminationHandler: WithdrawTerminationCommandHandler,
    printContractCommandHandler: PrintContractCommandHandler,
    printParkingContractCommandHandler: PrintParkingContractFormCommandHandler,
    showDocumentsHandler: ShowDocumentsCommandHandler,
    showInvoicesHandler: ShowLeaseAgreementInvoicesCommandHandler,
    eSignKeyRecieptHandler: ESignKeyRecieptCommandHandler
  ) {
    super();
    this.addHandler(leaseAgreementCommand.approve, approveHandler);
    this.addHandler(leaseAgreementCommand.createInvoice, createInvoiceHandler);
    this.addHandler(standardCommand.delete, deleteHandler);
    this.addHandler(standardCommand.edit, editHandler);
    this.addHandler(leaseAgreementCommand.exportNoPersonalData, exportNoPersonalDataHandler);
    this.addHandler(leaseAgreementCommand.export, exportHandler);
    this.addHandler(leaseAgreementCommand.linkDocument, linkDocumentHandler);
    this.addHandler(mailCommand.sendTenantEmail, sendEmailHandler);
    this.addHandler(mailCommand.sendTenantMail, sendMailHandler);
    this.addHandler(mailCommand.sendTenantSMS, sendSmsHandler);
    this.addHandler(leaseAgreementCommand.terminate, terminateHandler);
    this.addHandler(leaseAgreementCommand.withdrawApproval, withdrawApprovalHandler);
    this.addHandler(leaseAgreementCommand.withdrawTermination, withdrawTerminationHandler);
    this.addHandler(leaseAgreementCommand.print, printContractCommandHandler);
    this.addHandler(leaseAgreementCommand.printTerminationForm, printTerminationFormHandler);
    this.addHandler(leaseAgreementCommand.showDocuments, showDocumentsHandler);
    this.addHandler(leaseAgreementCommand.showInvoices, showInvoicesHandler);
    this.addHandler(leaseAgreementCommand.printParkingForm, printParkingContractCommandHandler);
    this.addHandler(leaseAgreementCommand.void, voidHandler);
    this.addHandler(leaseAgreementCommand.sendForEsignDocument, esignLeaseAgreementDocumentHandler);
    this.addHandler(leaseAgreementCommand.esignKeyReciept, eSignKeyRecieptHandler);
  }
}
